export default __webpack_public_path__ + "b4d39c36e0750580e50e7b69b6e47dfa.svg";